// Weblfow Accordions tend not to work well once exported
// This allows us to have a Strapi CMS linked Accordion
// May need some modificatons to match your webflow code structure

import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import "../css/Accordion.css";

const FAQs = ({ data }) => {
  const [lastClicked, setLastClicked] = useState(null);

  if (!data) return null;
  return (
    <>
      {data.map((el) => {
        return <AccordionItem key={uuid()} header={el.attributes.header} body={el.attributes.body} id={el.id} lastClicked={lastClicked} setLastClicked={setLastClicked} />;
      })}
    </>
  );
};

const AccordionItem = ({ header, body, id, lastClicked, setLastClicked }) => {
  const handleClick = () => {
    if (lastClicked === id) {
      setLastClicked(null);
    } else {
      setLastClicked(id);
    }
  };

  return (
    <div className="dropdownfaq" style={lastClicked === id ? { zIndex: 901, cursor: "pointer" } : { cursor: "pointer" }} onClick={handleClick}>
      <div data-w-id="f43a3349-bdc6-1a26-ab05-eeef14fc4731" className={`divfaq  ${lastClicked === id ? "w--open" : null}`}>
        <h4>{header}</h4>
        <div className="dropdowndiv">
          <img
            style={lastClicked !== id ? { display: "block" } : { display: "none" }}
            src="images/plus.svg"
            loading="lazy"
            width={16}
            height={16}
            alt="A plus symbol that extends a question."
            className="plus"
          />
          <img
            style={lastClicked === id ? { display: "block" } : { display: "none" }}
            src="images/minus-small.svg"
            loading="lazy"
            height={16}
            alt="A minus symbol that minimizes a question."
            className="minus"
          />
        </div>
      </div>
      <p className="paragraphfaq" style={lastClicked === id ? { display: "block", opacity: 1 } : { display: "block", opacity: 0, height: 0 }}>
        {body}
      </p>
    </div>
  );
};

export default FAQs;
